export const LOAD_HISTORY = 'LOAD_HISTORY';
export const REMOVE_HISTORY = 'REMOVE_HISTORY';
export const SET_HISTORY_PAGINATION = 'SET_HISTORY_PAGINATION';
export const LOAD_DISPLAY_USERS_HISTORY = 'LOAD_DISPLAY_USERS_HISTORY';
